export default {
  competitions_full: [],
  competitions_partial: [],
  competition_current: null,
}